module.exports = __webpack_public_path__ + "img/美团_04.fa39cdf7.jpg";